module.exports = {
  BASE_URL: 'http://localhost:3000',
  API_BASE_URL: 'https://ecommerce-store-endpoint.onrender.com'
};
